// Shared display/parse helpers for the Configuration sections (DJB-161..165).
// Prices travel as integer cents on the wire; the admin reads and types euros.

export const formatEuro = (cents) => {
  const value = Number(cents);
  if (!Number.isFinite(value)) return '—';
  return `€${(value / 100).toFixed(2)}`;
};

// "1.5" / "1,5" (euro input) -> 150 cents; null when not a usable number
export const euroToCents = (input) => {
  const value = parseFloat(String(input).replace(',', '.'));
  if (!Number.isFinite(value)) return null;
  return Math.round(value * 100);
};

export const centsToEuroInput = (cents) => {
  const value = Number(cents);
  if (!Number.isFinite(value)) return '';
  return (value / 100).toFixed(2);
};

export const parseIntOrNull = (input) => {
  const value = parseInt(input, 10);
  return Number.isFinite(value) ? value : null;
};

export const formatClockTime = (hour, minute) =>
  `${String(hour ?? 0).padStart(2, '0')}:${String(minute ?? 0).padStart(2, '0')}`;

// seconds -> "4:30" for the long-track thresholds
export const formatDuration = (seconds) => {
  const value = Number(seconds);
  if (!Number.isFinite(value)) return '—';
  const minutes = Math.floor(value / 60);
  const rest = value % 60;
  return `${minutes}:${String(rest).padStart(2, '0')}`;
};

// DJB-201: mirrors the JukeboxClient LongTrackPriceCalculator — a track costs
// 1 base credit plus the credits of every entry whose seconds threshold the
// track duration has reached. Entries don't need to be sorted.
export const simulateLongTrackCredits = (entries, seconds) =>
  (entries || []).reduce(
    (total, entry) =>
      Number(entry.seconds) <= seconds ? total + (Number(entry.credits) || 0) : total,
    1
  );

// The payment-mode entry DTO serializes the flag as isPayconiqPaymentEntry
// but deserializes (POST body) as payconiqEntry — accept both when reading.
export const isPayconiqEntry = (entry) =>
  Boolean(entry?.isPayconiqPaymentEntry ?? entry?.payconiqEntry);
